import React from "react";
import Lottie from "react-lottie";
import { Success } from "./../../Public/assets/index";
import { lottieOptions, reFormatDate } from "./../../Utils/helperFunction.js";
import { useOverview } from "./../../hooks.js";

const PaymentConfirmation = () => {
  const { BenificaryData, selectedCurrency, charges, selectedToCurrency } =
    useOverview();

  return (
    <div className="flex  py-6 ">
      <div className="w-full max-w-md">
        <div className="  space-y-4">
          <div className="flex justify-center">
            <div className="rounded-full">
              <Lottie
                options={lottieOptions(Success)}
                width={150}
                height={150}
              />
            </div>
          </div>
          <div className="text-center space-y-1">
            <h3 className="text-xl text-blackShade leading-[28px] font-normal">
              Your payment has been initiated
            </h3>
            <p className="text-sm font-normal text-greyish">
              Transfer ID : {BenificaryData?.data?.transactionNo}
            </p>
          </div>
          {/* <div className="flex justify-center">
            <Button className="  w-[85%]" variant="outline">
              <Download className="mr-2 h-4 w-4" /> Download Payment
              Confirmation
            </Button>
          </div> */}
          <div className="space-y-4 bg-greyish px-4 py-2.5 rounded">
            <div className="flex flex-col space-y-1 justify-between border-b py-2.5">
              <span className="text-xs font-normal text-greyish">You Paid</span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {BenificaryData?.data?.amount}{" "}
                {BenificaryData?.data?.toCurrency}
              </span>
            </div>
            {/* <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Remaining Balance
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {paymentData.remainingBalance} {paymentData.currency}
              </span>
            </div> */}
            {selectedCurrency?.vendorCurrency !== "USD" && (
              <div className="flex justify-between">
                <span className="text-xs font-normal text-greyish">
                  Exchange Rate
                </span>
                <span className="font-geomanistBold text-sm text-blackShade">
                  1 {selectedCurrency?.vendorCurrency} = {charges?.rate}{" "}
                  {selectedToCurrency?.vendorCurrency}
                </span>
              </div>
            )}
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Transfer Fee
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {BenificaryData?.data?.fees}{" "}
                {BenificaryData?.data?.fromCurrency}
              </span>
            </div>
          </div>
          <div className="space-y-4 bg-greyish px-4 py-2.5 rounded">
            {/* <div className="flex flex-col space-y-1 justify-between border-b py-2.5">
              <span className="text-xs font-normal text-greyish">
                Recipient Gets
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
               {paymentData.recipient.gets} {paymentData.recipient.currency} 
              </span>
            </div> */}
            {/* <div className="flex justify-between ">
              <span className="text-xs font-normal text-blackShade">
                {BenificaryData?.data?.receiverName} <br />
                 {paymentData.recipient.estimatedDelivery}) 
              </span>
              <span className="text-sm font-normal text-greyish">
                {BenificaryData?.data?.transferMethod}
              </span>
            </div> */}
            {/* <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">Bank</span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {paymentData.recipient.bank}
              </span>
            </div> */}
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Receiver Name
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {BenificaryData?.data?.receiverName}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Transfer Method
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {BenificaryData?.data?.transferMethod}
              </span>
            </div>
            {BenificaryData?.data?.accountNo !==null ? (
              <div className="flex justify-between">
                <span className="text-xs font-normal text-greyish">
                  Account Number
                </span>
                <span className="font-geomanistBold text-sm text-blackShade">
                  {BenificaryData?.data?.accountNo}
                </span>
              </div>
            ) : (
              <div className="flex justify-between">
                <span className="text-xs font-normal text-greyish">
                  IBAN
                </span>
                <span className="font-geomanistBold text-sm text-blackShade">
                  {BenificaryData?.data?.iban}
                </span>
              </div>
            )}
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Transfer Date
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {reFormatDate(BenificaryData?.data?.createdAt)}
              </span>
            </div>
            {/* <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Purpose to Transfer
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
               {paymentData.purposeOfTransfer} 
              </span>
            </div> */}

            {/* <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">Remarks</span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {paymentData.remarks}
              </span>
            </div> */}
          </div>
          {/* <div className="border-t pt-5 flex justify-end"> */}
          {/* <Button
              className=" font-geomanistBold  rounded-[8px] px-5 py-2.5"
              onClick={closeSheet}
              size="lg"
            >
              Back to Home
            </Button> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmation;
